export default __webpack_public_path__ + "static/media/lillith_korn.7643a2b0.webp";